import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children, adminOnly = false }) => {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  const tokenExpiry = localStorage.getItem("token_expiry");

  console.log("🔍 Checking PrivateRoute - Token:", token, "Role:", role);

  // Token or expiry missing
  if (!token || !tokenExpiry) {
    return <Navigate to="/" />;
  }

  // Token expired
  if (Date.now() > Number(tokenExpiry)) {
    localStorage.clear(); // Clear all login data
    return <Navigate to="/" />;
  }

  // Admin-only route but user is not admin
  if (adminOnly && role !== "admin") {
    return <Navigate to="/access-denied" />;
  }

  return children;
};

export default PrivateRoute;
